import React, { Component } from 'react'
import MetaTags from '../../elements/meta/metaTags.js'
import ButterClient from "../../elements/butterClient/butterClient.js"
import QueryString from 'query-string'
import { Columns, Container } from '../../elements'
import { trackPageView } from '../../elements/tracking/pagesAndMarketingTracking.js'

class PrivacyPolicy extends Component {
    constructor(props) {
        super(props);
        this.state = {
          data: {
              fields : {}
          },
        };
      }

    async componentDidMount () {
        const parsedQueries = QueryString.parse(this.props.location.search);
        let addtlParams = {}
        if(parsedQueries.preview === "1") { addtlParams['preview'] = 1 }
        const resp = await ButterClient.page.retrieve('*', 'privacy-policy', addtlParams)
        this.setState(resp.data)
        trackPageView('Privacy Policies', 'Marketing')
    }

    render() {

        return(
            <Container className="extra-small content">
                <MetaTags 
                    title={"Privacy Policy"}
                    description={"Twisted Road Privacy Policy."}
                    url={"/privacy-policy"}
                    type='company'
                /> 
                <Columns>
                    <Columns.Column>
                            <div dangerouslySetInnerHTML={{ __html: this.state.data.fields.main_page_copy }} />
                    </Columns.Column>
                </Columns>
            </Container>
        )
    }
}

export default PrivacyPolicy;










            
